import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getMiniPlayerData as getMiniPlayerDataAction } from 'redux/modules/navbar';

import { ENABLE_MINI_TEASE } from 'lib/brandFeatures.json';
import { miniPlayerTease as miniPlayerTeasePropType } from 'lib/CustomPropTypes';

import MsnbcTVE from './Tease/MsnbcTVE';
import NewsNow from './Tease/NewsNow';

const NEWS = 'news';
const ARTICLE = 'article';
const FRONT = 'front';
const MSNBC = 'msnbc';

const mapStateToProps = ({
  navbar,
  router,
  shared,
}) => ({
  miniPlayerData: navbar.miniPlayerData,
  pageView: shared.pageView,
  path: router.path,
  section: shared.section,
  vertical: shared.vertical,
});

const mapActionToProps = (dispatch) => ({
  getMiniPlayerData: (vertical) => dispatch(getMiniPlayerDataAction(vertical)),
});

class MiniPlayerTease extends React.Component {
  static propTypes = {
    getMiniPlayerData: PropTypes.func,
    miniPlayerLoaded: PropTypes.bool,
    miniPlayerData: PropTypes.oneOfType([
      PropTypes.string,
      miniPlayerTeasePropType,
    ]),
    onShowTease: PropTypes.func,
    pageView: PropTypes.string,
    path: PropTypes.string,
    section: PropTypes.string,
    vertical: PropTypes.string.isRequired,
  };

  static defaultProps = {
    getMiniPlayerData: Function.protoype,
    miniPlayerLoaded: false,
    miniPlayerData: {
      showTease: false,
    },
    onShowTease: Function.prototype,
    pageView: null,
    path: null,
    section: null,
  };

  componentDidMount() {
    const { miniPlayerLoaded } = this.props;
    if (!miniPlayerLoaded) {
      const { getMiniPlayerData, vertical } = this.props;
      if (ENABLE_MINI_TEASE[vertical]) {
        getMiniPlayerData(vertical);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { miniPlayerData: { showTease: wasShown } } = prevProps;
    const {
      pageView,
      miniPlayerData: { showTease: isShown, includedPageTypes = {} },
      onShowTease,
      vertical,
      path,
    } = this.props;

    const isNBCNews = vertical === NEWS;
    const isHomePage = path === '/';

    const isMSNBCNews = vertical === MSNBC;
    const isFront = pageView === FRONT && !isHomePage && includedPageTypes.front;
    const isArticle = pageView === ARTICLE && includedPageTypes.article;
    const isCover = includedPageTypes.cover && isHomePage;

    if (wasShown === false && isShown === true) {
      if (isNBCNews && isHomePage) onShowTease();

      if (isMSNBCNews) {
        if (isCover) onShowTease();
        if (isFront) onShowTease();
        if (isArticle) onShowTease();
      }
    }
  }

  shouldRender = () => {
    const { miniPlayerData } = this.props;
    if (miniPlayerData) {
      const {
        pageView,
        path,
        section,
        vertical,
      } = this.props;
      const {
        brand,
        includedPageTypes,
        excludedPages,
        showTease,
      } = miniPlayerData;
      if (includedPageTypes || excludedPages) {
        // Cover
        if (includedPageTypes.cover === true && pageView === 'front' && path === '/') {
          return true;
        }
        // Front / Article
        if (includedPageTypes[pageView]) {
          // Excluded pages
          const excludedArray = (typeof excludedPages === 'string' && excludedPages.split(/\n|\n\r/)) || [];
          return excludedArray.length === 0 || excludedArray.indexOf(path) === -1;
        }
      } else if (typeof brand !== 'undefined' && vertical === 'news' && section === '') {
        // News, only show on cover
        return showTease;
      }
    }
    return false;
  }

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    const {
      miniPlayerData,
      miniPlayerData: {
        brand,
      },
    } = this.props;

    let TeaseComponent;
    if (brand === 'MsnbcTVE') {
      TeaseComponent = MsnbcTVE;
    } else if (['newsnow', 'newsspecialreport'].includes(brand)) {
      TeaseComponent = NewsNow;
    }
    if (!TeaseComponent) {
      return null;
    }

    return (
      <div className="mini-player">
        <TeaseComponent {...miniPlayerData} />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapActionToProps)(
  MiniPlayerTease,
);
